import { Nomenclature } from './Nomenclature';
import { Person } from './Person';
import { FrxBaseBean } from './frxbasebean';
export class CaseSearch {
	id: number;
	claimant: string;
	defendant: string;
	caseNumber: string;
	damageNumber: string;
	prosecutorsNotice: string;
	dataPTP: string;
	mjastoPTP: string;
	criminalCase: string;
	mvrNumber: string;
	enforcementCase: string;
	traumaType: Nomenclature;
	traumaTypeName: string;
	traumaText: string;
	uvajeni: boolean;
	data_suzd_inst_grdelo_ot: string;
	data_suzd_inst_grdelo_do: string;
	responsible: number;
	traumaTypeId: number;
	vidSluchajId: number;
	prikljuchenoFilter: number;
	delaPretenciiFilter: number;
	sortField: string;
	sortDir: string;
	// Видими колони на екрана — пращат се само при Excel export, за да добави
	// бекендът видимите екстри към старите фиксирани колони. Optional → не пречи
	// на clearSearch литерала.
	visibleColumns?: string[];
}


